import { RemappedSecondaryPage } from 'models/types/appBar';
import pickBy from 'lodash/pickBy';
import findAvailableLocale from './findAvailableLocale';

const getRemappedLinks = (
  pages: any[],
  deviceName: 'mobile' | 'desktop',
  locale: string,
  handleClick: (string) => void,
): RemappedSecondaryPage[] => {
  const remappedLinks = pages.map(({
    action, kind, onClick, ...page
  }) => {
    const deviceAction = action[deviceName] ?? action.desktop ?? action.mobile;
    const isNewTab = deviceAction === 'NEWTAB';
    const localizedCustomHtml = findAvailableLocale(page.customHtml || {}, locale);

    const onClickAction = () => {
      if (!page.preventDefaultTracking) handleClick(page.name);
      onClick?.call(null);
      if (kind === 'HTML' && isNewTab) {
        const tab = window.open('', '', 'left=0,top=0,width=800,height=600,toolbar=0,scrollbars=0,status=0');
        tab.document.write(localizedCustomHtml);
        tab.document.close();
      }
    };

    const filteredButtonName = pickBy(page.buttonName, (localizedButtonName) => Boolean(localizedButtonName));

    return ({
      to: findAvailableLocale(page.path, locale) || '#',
      href: findAvailableLocale(page.src || {}, locale),
      customHtml: localizedCustomHtml,
      name: findAvailableLocale({ ...(page.pageTitle || {}), ...filteredButtonName }, locale),
      onClick: onClickAction,
      newTab: isNewTab,
    });
  });
  return remappedLinks;
};

export default getRemappedLinks;
